import { render, staticRenderFns } from "./deleteModal.vue?vue&type=template&id=03b63525&"
import script from "./deleteModal.vue?vue&type=script&lang=ts&"
export * from "./deleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./deleteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports